<template>
  <div class="col-12">
    <div class="alert alert-warning" role="alert">
      <div class="detail_body">
        <h6>
          راهنما: دقت کنید این سوالات در آزمون شفاهی پرسیده می‌شود و مصاحبه گر
          می‌تواند با داوطلب در مورد پاسخش وارد بحث شود

          <span class="text_details" @click="toggle">
            <span v-if="openText">بستن</span>
            <span v-else>ادامه متن</span>
          </span>
        </h6>

        <div :class="openText ? `open-tab` : ``" v-if="openText">
          <p>
            لذا ترجیح این است که سؤالاتی پیشنهاد شود که مهارت داوطلب را در موضوع
            سؤال بسنجد نه فقط دانش فرد را، لذا سؤالات پیشنهادی باید کاربردی یا
            مساله محور باشد، ضمنا پاسخ سوال یا راهنمای مصاحبه کننده برای قضاوت
            در مورد پاسخ داوطلب را نیز لازم است حتما قرار دهید. توجه کنید که
            مصاحبه گر در فرم مصاحبه پس از بحث با داوطلب و رسیدن به نتیجه در مورد
            هر سوال، ناظر به پاسخ داوطلب یکی از گزینه‌های زیر را انتخاب فقط
            می‌تواند انتخاب کند. ارائه پاسخ صحیح / ارائه پاسخ نسبتا صحیح / ارائه
            پاسخ نادرست
          </p>
          <p>
            فقط سوالات مرتبط با تخصص خود را اینجا پیشنهاد دهید «استاد ارشد» هر
            حوزه می‌تواند سوالات شما را ویرایش و رتبه بندی کند، بعد از ویرایش
            «استاد ارشد»، شما دیگر دسترسی برای اصلاح سوال پیشنهادی خود را
            نخواهید داشت. هر استاد لازم است در سامانه حداقل 10 سوال را ثبت کند،
            در صورت ثبت بیش از ده سوال با سطح کیفی خوب حتما زحمات اساتید محترم
            مورد قدردانی قرار خواهد گرفت.
          </p>
        </div>
      </div>
    </div>
    <Search
      :hiddenFields="hiddenFields"
      :allowFields="$lang.adminInterviewSearch"
      :allowCollapse="false"
      :url="url"
      :title="$lang.question_suggest"
      addModalSize="xl"
      removeModalSize="xl"
      :visibleSearch="true"
      :visibleSettings="true"
      :visibleExport="true"
      :visibleFilters="true"
      :visibleViewCount="true"
      :allowEdit="false"
      :dynamicButtons="availableButtons"
      ref="interviewSearch"
      routeName="edit_question_suggest"
      :filterCatch="true"
      @getPermisson="getPermissions"
      :visibleAdd="isAdmin(permissions, ['admin'])"
    >
      <template slot="addModal" slot-scope="search">
        <AddQuestionSuggest @cancel="search.close" @getItems="getItems" />
      </template>
    </Search>
  </div>
</template>

<script>
import Search from "@/components/base/search";
import AddQuestionSuggest from "./addQuestionSuggest";
import { isAdmin, generateApiUrl, generateCurrentRoute } from "@/shared/utils";

export default {
  components: {
    Search,
    AddQuestionSuggest,
  },
  data() {
    return {
      hiddenFields: [
        "created_by",
        "confirmed_person.full_name",
        "question_suggest_quality_evaluation.caption",
      ],
      openText: false,
      buttons: [
        {
          id: "0",
          name: "edit",
          is_confirmed: [0, 1],
        },
        {
          id: "1",
          name: "view",
          is_confirmed: [0, 1],
        },
        {
          id: "4",
          name: "delete",
          is_confirmed: [0],
        },
      ],
      permissions: [],
    };
  },
  computed: {
    url() {
      return generateApiUrl(["interview", "question_suggest"]);
    },
  },
  methods: {
    isAdmin,
    generateApiUrl,
    toggle() {
      this.openText = !this.openText;
    },
    availableButtons(item) {
      return this.buttons.filter((x) =>
        x.is_confirmed.includes(item.is_confirmed)
      );
    },
    getItems() {
      this.$refs.interviewSearch.getItems();
    },
    getPermissions(permissions) {
      this.permissions = permissions;
    },
  },
  mounted() {
    const currentRouteName = generateCurrentRoute();
    localStorage.setItem("questionSuggestBackRoute", currentRouteName);
  },
};
</script>
<style>
.open-tab {
  animation: open 1s;
}
.detail_body {
  display: block;
}
.text_details {
  cursor: pointer;
  color: red;
}

@keyframes open {
  0% {
    opacity: 0;
    transform: translateY(-10px);
  }

  100% {
    opacity: 1;
    transform: translateY(0);
  }
}
</style>
